@if (notification) {
  <div class="alert alert-success">{{ notification }}</div>
}

<div class="card bg-light">
  <div class="card-header">
    <h3 class="panel-title">Group creation</h3>
  </div>
  <div class="card-body">
    <div class="alert alert-info">Group creation can require a few minutes to be effective</div>
    @if (success_msg) {
      <div class="alert alert-success">{{ success_msg }}</div>
    }
    @if (err_msg) {
      <div class="alert alert-danger">{{ err_msg }}</div>
    }
    <form role="form" class="user-form form-inline">
      <div class="form-group">
        <input placeholder="Group name" type="text" [ngModelOptions]="{ standalone: true }" [(ngModel)]="new_group.name" class="form-control" />
      </div>
      <div class="form-group">
        <input placeholder="Owner" type="text" [ngModelOptions]="{ standalone: true }" [(ngModel)]="new_group.owner" class="form-control" />
      </div>
      <div class="form-group">
        <input placeholder="Description" type="text" [ngModelOptions]="{ standalone: true }" [(ngModel)]="new_group.description" class="form-control" />
      </div>
      <div class="form-group">
        <p-button type="button" size="small" severity="secondary" (onClick)="addGroup()" label="Create"></p-button>
      </div>
    </form>
  </div>
</div>

<div class="card bg-light">
  <div class="card-header">
    <h3>Groups</h3>
  </div>
  <div class="card-body">
    <div class="table-responsive table-striped">
      <p-table #dtg [value]="groups" [paginator]="true" [rows]="10" [showCurrentPageReport]="true" [rowsPerPageOptions]="[10, 25, 50]" [globalFilterFields]="['name', 'gid', 'owner', 'tags', 'description']" [filterDelay]="0" sortMode="multiple">
        <ng-template pTemplate="caption">
          <div class="table-header">
            <span class="p-input-icon-right">
              <i class="pi pi-search"></i>
              <input pInputText id="search_groups" type="text" (input)="dtg.filterGlobal($event.target.value, 'contains')" placeholder="Global Search" />
            </span>
          </div>
        </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="name">Group <p-sortIcon field="name"></p-sortIcon></th>
            <th pSortableColumn="gid">Gid <p-sortIcon field="gid"></p-sortIcon></th>
            <th pSortableColumn="owner">Owner <p-sortIcon field="owner"></p-sortIcon></th>
            <th pSortableColumn="description">Description <p-sortIcon field="description"></p-sortIcon></th>
            <th pSortableColumn="tags">Tags <p-sortIcon field="tags"></p-sortIcon></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-group>
          <tr>
            <td>
              <a routerLink="/admin/group/{{ group.name }}">
                <span class="p-button p-button-sm p-button-primary">{{ group.name }}</span>
              </a>
            </td>
            <td>{{ group.gid }}</td>
            <td>
              @if (group.owner) {
                <a routerLink="/user/{{ group.owner }}">
                  <span class="p-button p-button-sm p-button-primary">{{ group?.owner }}</span>
                </a>
              }
            </td>
            <td>{{ group.description }}</td>
            <td>{{ group.tags ? group.tags.join(", ") : "" }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
